import { baseURL } from "./config";
const axios = require('axios').default;


const apiCall = axios.create({
   baseURL
})

const setAuthorizationHeader = ( token ) => {
   apiCall.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

setAuthorizationHeader(localStorage.getItem('token'));

// let isAlreadyFetchingAccessToken = false
// let subscribers = []
//
// function onAccessTokenFetched (access_token) {
//    subscribers = subscribers.filter(callback => callback(access_token))
// }
//
// function addSubscriber (callback) {
//    subscribers.push(callback)
// }
//
// apiCall.interceptors.response.use(function (response) {
//    return response;
// }, function (error) {
//    // const { config, response: { status } } = error
//    const { config, response } = error
//    const originalRequest = config
//
//    // if (status === 401) {
//    if (response && response.status === 401) {
//       if (!isAlreadyFetchingAccessToken) {
//          isAlreadyFetchingAccessToken = true
//          const token = response.data.token;
//          localStorage.setItem("token", token);
//          apiCall.defaults.headers.common['Authorization'] = `Bearer ${token}`
//          localStorage.setItem("user", JSON.stringify(response.data.user));
//          onAccessTokenFetched(token)
//       }
//
//       const retryOriginalRequest = new Promise((resolve) => {
//          addSubscriber(access_token => {
//             originalRequest.headers.Authorization = `Bearer ${access_token}`
//             resolve(axios(originalRequest))
//          })
//       })
//       return retryOriginalRequest
//    }
//    return Promise.reject(error)
// })

export default apiCall;